import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
// React Bootstrap
import { Form, Button, Col, Image } from "react-bootstrap";
// Utils
import { juridicPersonality, juridicProperty } from "../../../../contexto";

const FormJuridicos = ({ defaultValues, submissionHandler, ...props }) => {

  // console.log(defaultValues)
  const [validated] = useState(false);
  // const [convenio, setConvenio] = useState(defaultValues.convenio)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data);

  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="property-work">
          <Form.Label>{"Propiedad"}</Form.Label>
          <Form.Control name="property" as="select" custom isInvalid={errors.property} {...register("property")}>
            {juridicProperty.map((value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group as={Col} xs={12} md controlId="legal-form-work">
          <Form.Label>{"Personalidad jurídica"}</Form.Label>
          <Form.Control name="legalForm" as="select" custom isInvalid={errors.legalForm} {...register("legalForm")}>
            {juridicPersonality.map((value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        {/* <Form.Group as={Col} xs={12} md controlId="convenio-form-work">

          {convenio ?
            <>
              <a href={`${process.env.REACT_APP_API_URL}/provincias/${defaultValues.provinceId}/misiones/${defaultValues.id}/documentos/${convenio}`} target="_blank" rel="noreferrer">
                Convenio
              </a>
              <Button
                variant="light"
                className="ml-3"
                onClick={() => { setConvenio(false) }}
              >
                <Image width="25" fluid src={"/svg/trash-outline.svg"}></Image>
              </Button>
            </>
            : (
              <>
                <Form.Label>{"Convenio"}</Form.Label>
                <Form.Control name="convenio" type="file" custom isInvalid={errors.convenio} {...register("convenio")}>
                </Form.Control>
              </>
            )
          }
        </Form.Group> */}
      </Form.Row>
      <Form.Group>
        <Button type="submit" variant="outline-primary" className={"w-100"}>
          Guardar
        </Button>
      </Form.Group>
    </Form >
  );
};

export default FormJuridicos;
